export type IndeedFailureCardTreatment = 'not-sent' | 'not-delivered';

const NOT_SENT_REASONS = new Set(['ALREADY_CONTACTED', 'RECENTLY_DECLINED']);

export const getIndeedFailureCardTreatment = (failureReason?: string | null): IndeedFailureCardTreatment =>
  failureReason && NOT_SENT_REASONS.has(failureReason) ? 'not-sent' : 'not-delivered';

export const DESIGNED_FAILURE_REASONS = new Set([
  'ALREADY_CONTACTED',
  'RECENTLY_DECLINED',
  'SUBSCRIPTION_MISMATCH',
  'RETRY_WINDOW_EXPIRED',
]);

export const isIndeedFailureRetryable = (failureReason?: string | null): boolean =>
  failureReason === 'RETRY_WINDOW_EXPIRED' || failureReason === 'SUBSCRIPTION_MISMATCH';
